const MODULE_NAME = 'myAccount';

const _myAccountSelector = {
    isShowChangePassPopup: (state) => state[MODULE_NAME].isShowChangePassPopup,
};

export default _myAccountSelector;
